import React, { useEffect } from 'react';
import Card from './components/Card';
import { getCoreWebVitals, getOtherWebVitals } from './utilities/getWebVitals';

export const App = (props) => {
  useEffect(() => {
    const { queryParams, initialState } = props;
    const { webVitalsLogType } = initialState;
    if (queryParams && queryParams.templateId) {
      const { templateId } = queryParams;
      getCoreWebVitals(templateId, webVitalsLogType);
      getOtherWebVitals(templateId, webVitalsLogType);
    }
  }, []);

  return (
    <div>
      <Card {...props} />
    </div>
  );
};

export default App;
